import { createFileRoute } from '@tanstack/react-router'

import { AppointmentTabPage } from "~/features/dashboard/pages/appointments";
import { appointmentsQueryOptions } from '~/features/dashboard/pages/appointments/api/queries';

export const Route = createFileRoute(
  '/(dashboard)/dashboard/weight-loss/appointments/$tab',
)({
  beforeLoad: async ({ params }) => {
    const type = params.tab;
    if (type !== "upcoming" && type !== "past") {
      return "upcoming";
    }
  },
  loader: ({ context, params }) => {
    context.queryClient.ensureQueryData(appointmentsQueryOptions({ type: params.tab }))
    // context.queryClient.ensureQueryData(appointmentsQueryOptions({ type: "upcoming" }))
    // context.queryClient.ensureQueryData(appointmentsQueryOptions({ type: "past" }))
  },

  component: () => <AppointmentTabPage />,
})

